(function(){
  var money = window.Oshea && window.Oshea.moneyFormat || '{{amount}} ₪';
  function fmt(cents){
    var v = (cents/100).toFixed(2).replace(/\.00$/,'');
    return money.replace(/\{\{\s*amount[^}]*\}\}/, v);
  }
  window.osheaFormatMoney = fmt;

  var toastEl;
  function toast(msg){
    if(!toastEl){ toastEl = document.createElement('div'); toastEl.className='toast'; document.body.appendChild(toastEl); }
    toastEl.textContent = msg;
    requestAnimationFrame(function(){ toastEl.classList.add('show'); });
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function(){ toastEl.classList.remove('show'); }, 2400);
  }
  window.osheaToast = toast;

  function openDrawer(){ document.body.classList.add('drawer-open'); }
  function closeDrawer(){ document.body.classList.remove('drawer-open'); }
  window.osheaOpenDrawer = openDrawer;

  function refreshCart(open){
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + '?sections=cart-drawer' : '/?sections=cart-drawer')
      .then(function(r){ return r.json(); })
      .then(function(j){
        var html = j['cart-drawer'];
        if(html){
          var doc = new DOMParser().parseFromString(html,'text/html');
          var fresh = doc.querySelector('[data-cart-drawer]');
          var live = document.querySelector('[data-cart-drawer]');
          if(fresh && live) live.innerHTML = fresh.innerHTML;
          var c = doc.querySelector('[data-cart-count]');
          document.querySelectorAll('[data-cart-count]').forEach(function(n){ if(c) n.textContent = c.textContent; });
        }
        if(open) openDrawer();
      });
  }
  window.osheaRefreshCart = refreshCart;

  function addItems(items, msg){
    return fetch('/cart/add.js', {
      method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({ items: items })
    }).then(function(r){
      if(!r.ok) return r.json().then(function(e){ throw new Error(e.description || 'خطأ'); });
      return r.json();
    }).then(function(){
      return refreshCart(true).then(function(){ if(msg) toast(msg); });
    }).catch(function(e){ toast(e.message); });
  }
  window.osheaAdd = addItems;

  function changeLine(key, qty){
    return fetch('/cart/change.js',{
      method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({ id:key, quantity:qty })
    }).then(function(){ return refreshCart(false); });
  }

  document.addEventListener('click', function(e){
    var t = e.target.closest('[data-cart-toggle]');
    if(t){ e.preventDefault(); openDrawer(); return; }
    if(e.target.closest('[data-cart-close]') || e.target.matches('.drawer-bg')){ closeDrawer(); return; }

    var add = e.target.closest('[data-add]');
    if(add){
      e.preventDefault();
      var id = add.getAttribute('data-add');
      var q = parseInt(add.getAttribute('data-qty')||'1',10);
      add.disabled = true;
      addItems([{id:parseInt(id,10), quantity:q}], add.getAttribute('data-msg')||'أُضيف إلى السلة')
        .then(function(){ add.disabled = false; });
      return;
    }

    var ch = e.target.closest('[data-change]');
    if(ch){
      e.preventDefault();
      changeLine(ch.getAttribute('data-key'), parseInt(ch.getAttribute('data-change'),10));
      return;
    }

    var burger = e.target.closest('[data-menu-toggle]');
    if(burger){ document.querySelector('.mobile-nav').classList.toggle('open'); return; }
    if(e.target.closest('[data-menu-close]')){ document.querySelector('.mobile-nav').classList.remove('open'); }
  });

  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape'){ closeDrawer(); document.querySelectorAll('.pop-bg.open').forEach(function(p){ p.classList.remove('open'); }); }
  });

  // quantity steppers
  document.addEventListener('click', function(e){
    var s = e.target.closest('[data-step]');
    if(!s) return;
    var input = s.parentElement.querySelector('input');
    if(!input) return;
    var v = parseInt(input.value||'1',10) + parseInt(s.getAttribute('data-step'),10);
    input.value = Math.max(1, v);
    input.dispatchEvent(new Event('change', {bubbles:true}));
  });

  // scroll reveal
  var io = new IntersectionObserver(function(es){
    es.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('in'); io.unobserve(en.target); } });
  }, { rootMargin:'0px 0px -6% 0px', threshold:.05 });
  function observe(){
    document.querySelectorAll('[data-reveal]:not(.in)').forEach(function(n,i){
      n.style.transitionDelay = (i%4)*0.08 + 's';
      var r = n.getBoundingClientRect();
      if(r.top < window.innerHeight*0.92){ n.classList.add('in'); } else { io.observe(n); }
    });
  }
  document.addEventListener('DOMContentLoaded', observe);
  document.addEventListener('shopify:section:load', observe);
  observe();

  // before / after
  function initBA(root){
    (root||document).querySelectorAll('[data-ba]:not([data-ba-init])').forEach(function(el){
      el.setAttribute('data-ba-init','1');
      var top = el.querySelector('.ba-top'), line = el.querySelector('.ba-line'), knob = el.querySelector('.ba-knob');
      var rtl = document.documentElement.dir === 'rtl';
      var down = false;
      function set(x){
        var b = el.getBoundingClientRect();
        var p = ((x - b.left)/b.width)*100;
        if(rtl) p = 100 - p;
        p = Math.max(3, Math.min(97, p));
        top.style.clipPath = rtl ? 'inset(0 ' + (100-p) + '% 0 0)' : 'inset(0 0 0 ' + (100-p) + '%)';
        var side = rtl ? 'right' : 'left';
        line.style[side] = p + '%'; knob.style[side] = p + '%';
        line.style[rtl?'left':'right'] = 'auto'; knob.style[rtl?'left':'right'] = 'auto';
      }
      el.addEventListener('pointerdown', function(e){ down=true; el.setPointerCapture(e.pointerId); set(e.clientX); });
      el.addEventListener('pointermove', function(e){ if(down) set(e.clientX); });
      el.addEventListener('pointerup', function(){ down=false; });
      el.addEventListener('pointercancel', function(){ down=false; });
      var b0 = el.getBoundingClientRect();
      set(b0.left + b0.width*(document.documentElement.dir==='rtl'?0.48:0.52));
    });
  }
  document.addEventListener('DOMContentLoaded', function(){ initBA(); });
  document.addEventListener('shopify:section:load', function(e){ initBA(e.target); });
  initBA();
})();